import {
    ecsApi,
    GetOperatorsResponse,
} from '@services';

export const operatorsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getOperators: builder.mutation<GetOperatorsResponse, void>({
            query: () => ({
                url: '/operators',
                method: 'GET'
            })
        }),
    })
});

export const {
    useGetOperatorsMutation,
} = operatorsApi;
